import Radio from 'antd/lib/radio'
import './index.less'

export default Radio



// WEBPACK FOOTER //
// ./src/elements/radio/index.js